import clsx from "clsx";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { RequiredItem } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import { OptionItem, Select } from "@transfr-inc/dashboard-components/forms";
import { getProducts } from "@transfr-inc/dashboard-components/utils";

export const productOptions = () => {
  const isProgramsEnabled =
    process.env.PROGRAMS_ENABLED?.toUpperCase() === "TRUE";
  return (
    getProducts()
      .filter((product) => isProgramsEnabled || product.id !== Product.PROG)
      // Filter out products with non-numeric IDs,
      // this means is a product without a valid ID
      .filter((product) => Number(product.id))
      .map(
        (product) =>
          new OptionItem({
            id: product.id,
            text: product.displayName,
            data: product,
          }),
      )
  );
};

export const getProductsOptions = (products) =>
  products
    ?.map((p) => productOptions().find((po) => po.id === p))
    .filter((p) => p);

const defaultPlaceholder =
  "Select one or more products for this organization...";

export function OrgProductsEditor({
  placeholder,
  className,
  name = "products",
}) {
  const { control } = useFormContext();

  return (
    <div className={clsx("editor-section", className)}>
      <div className="section-title">
        <h2>
          <RequiredItem text="Products" />
        </h2>
      </div>
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        name={name}
        render={({ field: { value, onChange } }) => {
          return (
            <Select
              selected={value ?? []}
              placeholder={placeholder ?? defaultPlaceholder}
              icon={["fa-light", "fa-objects-column"]}
              onOptionsChange={onChange}
              className={"product-select"}
              options={productOptions}
            ></Select>
          );
        }}
      />
    </div>
  );
}
